angular.module('rjmNg.services').factory('sqlService', [
  "$sce"
  "encodedLetterString"
  ($sce, encodedLetterString) ->

    _escapeForPostgres = (str) ->
      str.replace(/"/g,'""')

    buildSelect = (calc, inputs, table) ->
      raw = calc
      inputSql = ""
      for col in inputs
        letter = encodedLetterString.indexToAlpha(col.inputId, false)
        inputSql += "\"#{table}\".\"#{col.column}\" as \"#{letter}\", "
        regex = new RegExp(letter, "g")
        raw = raw.replace(regex, "\"#{table}\".\"#{col.column}\"")
      return "#{inputSql}#{raw} as \"#{_escapeForPostgres(calc)}\""

    sqlService =

      getTestQuery: (calc, inputs, table, limit) ->
        "SELECT #{buildSelect(calc, inputs, table)} from \"#{table}\" limit #{limit}"

      canValidateQuery: (inputs) ->
        for input in inputs when input.type is "derivative"
          return false
        return true

  ]
)
